const redirectUri = `${window.location.origin}${process.env.PUBLIC_URL}/callback`;
const clientId = FC_CLIENTID || "";

export const goToUrlFacebook = (flowType = '', utm?: Record<string, string>) => {
  const flowTypeParam = flowType ? `&${flowType}` : '';
  const state = encodeURIComponent(`facebook${flowTypeParam}`);
  localStorage.setItem("stateAuthSocial", state);

  if (utm) {
    const utmString = Object.entries(utm)?.map(([key, value]) => `${key}=${value}`)?.join('&')
    localStorage.setItem("utmAuthSocial", `${utmString}`);
  }

  let url = "https://www.facebook.com/v19.0/dialog/oauth";
  url += "?response_type=token";
  url += "&client_id=" + encodeURIComponent(clientId);
  url += "&scope=" + encodeURIComponent("email,user_birthday,user_likes");
  url += "&redirect_uri=" + encodeURIComponent(redirectUri);


  url += "&state=" + state;
  window.location.href = url;
}